import Icon from '../components/Icon.vue'

Icon.register({
  futbol: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM456 256L456 255.7 429.9 278.5 367.3 220 383.7 135.6 418 138.7C393.1 104.5 358 78.6 317.3 65.5L331 97.5 256 139 181 97.5 194.7 65.5C154.1 78.6 118.9 104.4 94 138.7L128.6 135.6 144.7 220 82.1 278.5 56 255.7 56 256C56 299 69.5 340 94.5 374L102.2 340.1 187.3 350.5 223.6 428.4 193.7 446.2C233.9 459.3 278 459.3 318.3 446.2L288.4 428.4 324.7 350.5 409.8 340.1 417.5 374C442.5 340 456 299 456 256zM207.9 325.6L178 234.3 256 177.7 334 234.3 304.4 325.6H207.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/futbol.js
// module id = /D+p
// module chunks = 144